import React from "react";
import { LanguageConstants } from "../../../constants/LanguageConstants";

type Props = { status: string | number | undefined };

export function QuotationStatusBadge({ status }: Props) {
  const s = String(status ?? "");
  let label = LanguageConstants?.NEW_PENDING ?? "Pending";
  let mod = "vq-badge--pending";
  // DB status 0: Quoting (unassigned or admin working). DB status 1: Quoted after admin submit.
  if (s === "0") {
    label = LanguageConstants?.NEW_PENDING ?? "Quoting";
    mod = "vq-badge--quoting";
  } else if (s === "1") {
    label = LanguageConstants?.NEW_Progress ?? "Quoted";
    mod = "vq-badge--quoted";
  } else if (s === "2") {
    label = LanguageConstants?.APPROVED ?? "Approved";
    mod = "vq-badge--approved";
  } else if (s === "3") {
    label = LanguageConstants?.REJECT ?? "Rejected";
    mod = "vq-badge--rejected";
  } else if (s === "4") {
    label = LanguageConstants?.DRAFTS ?? "Draft";
    mod = "vq-badge--draft";
  }
  return <span className={`vq-badge ${mod}`}>{label}</span>;
}
